// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".arrow-back {\n  background-color: transparent;\n  display: flex;\n  align-items: flex-end;\n  color: #fff;\n  justify-content: center;\n  padding: 0px 15px 131px 43px;\n  cursor: pointer;\n}\n.arrow-back svg {\n  margin-right: 7px;\n}", ""]);
// Exports
module.exports = exports;
